
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"financeInfoFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CreditApplicationFinanceInfo"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bankInfo"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"bankInfoFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"selectedBankInfo"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"bankInfoFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"desiredCredit"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"expectedSpend"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":221}};
    doc.loc.source = {"body":"#import './bankInfoFragment.gql'\n\nfragment financeInfoFragment on CreditApplicationFinanceInfo {\n  bankInfo {\n    ...bankInfoFragment\n  }\n  selectedBankInfo {\n    ...bankInfoFragment\n  }\n  desiredCredit\n  expectedSpend\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require('./bankInfoFragment.gql').definitions));


      module.exports = doc;
    
